module.exports = __webpack_public_path__ + "static/media/close.6897f481.svg";